import { render, staticRenderFns } from "./HistoryCredits.vue?vue&type=template&id=395020c9&scoped=true"
import script from "./HistoryCredits.vue?vue&type=script&lang=js"
export * from "./HistoryCredits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395020c9",
  null
  
)

export default component.exports